export default (data) => ({
  type: 'UPDATE_JOBS',
  payload: data,
});
